import * as _ from "lodash";
namespace Blackboard {
  export let commonState = {};
  export let blackboardState = {};
  export let createDisplayMap = {};
  export function saveBlackboard(): any {
    return {
      commonState,
      blackboardState
    };
  }
  export function loadBlackboard(
    blackboardSavedState: any = {},
    hardOverride = true
  ): void {
    if (hardOverride) {
      Blackboard.commonState = blackboardSavedState.commonState || {};
      Blackboard.blackboardState = blackboardSavedState.blackboardState || {};
    } else {
      _.assign(Blackboard.commonState, blackboardSavedState.commonState || {});
      _.assign(
        Blackboard.blackboardState,
        blackboardSavedState.blackboardState || {}
      );
    }
  }
  export function setState(state: {}, blackboardId?: string): void {
    if (blackboardId) {
      Blackboard.blackboardState[blackboardId] =
        Blackboard.blackboardState[blackboardId] || {};
      _.assign(Blackboard.blackboardState[blackboardId], state);
    } else {
      _.assign(commonState, state);
    }
  }
  export function getState(path?: string, blackboardId?: string): any {
    if (blackboardId) {
      return path
        ? _.get(Blackboard.blackboardState[blackboardId], path)
        : Blackboard.blackboardState[blackboardId];
    } else {
      return path
        ? _.get(Blackboard.commonState, path)
        : Blackboard.commonState;
    }
  }
  export function getCreateDisplay(plist: string, symbol: string): any {
    if (!Blackboard.createDisplayMap[plist + symbol]) {
      Blackboard.createDisplayMap[
        plist + symbol
      ] = flax.assetsManager.createDisplay(plist, symbol);
    }
    return Blackboard.createDisplayMap[plist + symbol];
  }
}

export default Blackboard;
